
























































































import _ from "lodash";
import { Component, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";
import { Maintenancejob, EmailLog } from "@/models";
@Component({
  components: {}
})
export default class EmailHistory extends Vue {
  public emailHistory: any = [];
  public maintenancejob: Maintenancejob;
  public currentsection: EmailLog = new EmailLog();
  public currentindex: number = 0;

  @Action("maintenancejobs/getMaintenancejob")
  public getMaintenancejob: (id: string) => Promise<Maintenancejob>;

  /**
   * Run init() on mounted...
   */
  public mounted() {
    this.init();
  }
  /**
   * Get Report
   *
   * @returns {Promise}
   */
  public async init() {
    await this.getMaintenancejob(this.$route.params.id)
      .then((maintenancejobData: Maintenancejob) => {
        if (maintenancejobData === undefined) {
          this.$onecentral.displayError("Could not load Report");
          this.$router.push({ name: "maintenancejobs" });
        } else {
          this.emailHistory = [...maintenancejobData.emaillogs];
          this.maintenancejob = maintenancejobData;
          this.currentsection = this.emailHistory[this.currentindex];
        }
      })
      .catch((err: any) => {
        this.$onecentral.displayError(err);
      });
  }

  public toggleselectsection(index: any) {
    if (this.currentindex === index) {
      this.currentindex = -1;
      this.currentsection = new EmailLog();
    } else {
      this.currentindex = index;
      this.currentsection = this.emailHistory[index];
    }
  }
  get addressLine1(): string {
    return this.maintenancejob.address.line1;
  }

  get addressLine2(): string {
    return this.maintenancejob.address.line2;
  }

  get addressPostcode(): string {
    return this.maintenancejob.address.postcode;
  }

  public addressPreviewLine1() {
    return `${this.addressLine1}${
      this.addressLine2 ? `, ${this.addressLine2}` : ""
    }`;
  }
  public addressPreviewLine2() {
    return `${this.addressPostcode}`;
  }
}
